import { useCallback, useMemo, useRef, useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  // Grid,
  Container,
  CircularProgress,
  useTheme,
  Grid,
  // Paper,
  Link,
} from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
// import RoomIcon from "@mui/icons-material/Room";
import { useNavigate, useParams, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setStoreData as setStore } from "../redux/action";
import { getAPI } from "../api/callAPI";
import { isObject } from "lodash";
import NotFound from "../Common/NotFound";
import UpcomingEvents from "../Common/UpcomingEvents";
import Facilities from "../Common/Facilities";
import ImageGallery from "../Common/ImageGallery";
import MenuButton from "../Common/MenuButton";
import OpeningHours from "../Common/OpeningHours";
import { TbMapShare } from "react-icons/tb";
// import { MdMyLocation } from "react-icons/md";
import { LuMapPin } from "react-icons/lu";
import { RiUserAddLine } from "react-icons/ri";
import { FaInstagram } from "react-icons/fa";
import { FiFacebook } from "react-icons/fi";
import { CiYoutube } from "react-icons/ci";
import { RiTwitterXLine } from "react-icons/ri";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { checkMultiStore, getConfigText } from "../Common/utils";
// import { IoShareSocialOutline, IoCopyOutline } from "react-icons/io5";
// import Footer from "../Common/Footer";
// const mapping = {
//   "romeo-lane-civil-lines-delhi" : "1",
//   "romeo-lane-noida" : "3",
//   "romeo-lane-zirakpur" : "4",
//   "romeo-lane-gurugram" : "5",
//   "romeo-lane-meerut" : "6",
//   "romeo-lane-bhopal" : "7",
//   "romeo-lane-vagator-goa" : "8",
//   "romeo-lane-bhubaneswar" : "9",
//   "romeo-lane-yamuna-nagar" : "10",
//   "romeo-lane-lucknow" : "11",
//   "romeo-lane-kanpur" : "12",
//   "romeo-lane-karnal" : "13",
//   "romeo-lane-mohali" : "14",
//   "tan-n-tonic" : "15",
//   "romeo-lane-dubai" : "16",
//   "birch-by-romeo-lane-nsp" : "17",
//   "romeo-lane-the-courtyard-house" : "18",
//   "birch-by-romeo-lane-goa" : "19",
//   "birch-by-romeo-lane-noida" : "20",
//   "romeolane-nagpur" : "22",
//   "romeo-lane-indore" : "23"
// };

// const getStoreID = (storeSlug) => {
//   return mapping[storeSlug] || null;
// };

const StoreDetails = () => {
  const { storeSlug } = useParams();
  const { palette } = useTheme();
  const eventsRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { endpoint, appConfigs } = useSelector((state) => state.auth);
  const [expanded, setExpanded] = useState(false);
  const [storeLoading, setStoreLoading] = useState(true);
  const [storeData, setStoreData] = useState(null);
  const [error, setError] = useState("");
  // const [data, setData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [eventData, setEventData] = useState(null);

  // const storeID = useMemo(() => {
  //   if (location.pathname) {
  //     return location.pathname.replace("/details/", "");
  //   }
  //   return null;
  // }, [location.pathname]);

  const storeID = useMemo(() => {
    return storeData?.id;
  }, [storeData]);

  const checkStore = useCallback(async () => {
    if (storeSlug) {
      dispatch(setStore({}));
      setStoreLoading(true);
      try {
        const resp = await getAPI(endpoint, `stores/${storeSlug}`);
        dispatch(setStore(resp?.data["0"]));
        setStoreData(resp?.data["0"]);
      } catch (error) {
        console.error("checkStore error >>> ", error);
        dispatch(setStore({}));
        setStoreData(null);
        setError("Store Not Found");
      }
      setStoreLoading(false);
    } else {
      setStoreData(null);
      dispatch(setStore({}));
      setError("Store Not Found");
      setStoreLoading(false);
    }
  }, [storeSlug, dispatch, endpoint]);

  useEffect(() => {
    checkStore();
  }, [checkStore, endpoint]);

  const isMultiStore = useMemo(() => checkMultiStore(endpoint), [endpoint]);

  // Get config values
  const bookTableEnabled = useMemo(() => {
    const enabled = getConfigText(appConfigs, 'book_a_table_enabled');
    return enabled === '1' || enabled === 'true';
  }, [appConfigs]);

  const viewMenuEnabled = useMemo(() => {
    const enabled = getConfigText(appConfigs, 'view_menu_enabled');
    return enabled === '1' || enabled === 'true';
  }, [appConfigs]);

  const orderNowEnabled = useMemo(() => {
    const enabled = getConfigText(appConfigs, 'order_now_enabled');
    return enabled === '1' || enabled === 'true';
  }, [appConfigs]);

  const storeInactiveNotice = useMemo(
    () => getConfigText(appConfigs, 'app_store_inactive_notice'),
    [appConfigs]
  );

  const bookAroomEnabled = useMemo(() => {
    const enabled = getConfigText(appConfigs, 'book_a_room_enabled');
    return enabled === '1' || enabled === 'true';
  }, [appConfigs]);

  const bookAroomLink = useMemo(() => {
    return getConfigText(appConfigs, 'book_a_room_link') || '';
  }, [appConfigs]);

  const webImage = useMemo(() => {
    return getConfigText(appConfigs, 'web_image');
  }, [appConfigs]);

  // Set dynamic page title
  useDocumentTitle(storeData?.name || "Store Details");

  // const handleCopy = () => {
  //   const url = window.location.href;

  //   if (navigator?.clipboard?.writeText) {
  //     navigator.clipboard
  //       .writeText(url)
  //       .then(() => {
  //         alert("Link copied to clipboard!");
  //       })
  //       .catch((err) => {
  //         console.error("Clipboard write failed:", err);
  //         fallbackCopy(url);
  //       });
  //   } else {
  //     fallbackCopy(url);
  //   }
  // };

  // Fallback method using a hidden input
  // const fallbackCopy = (text) => {
  //   const textarea = document.createElement("textarea");
  //   textarea.value = text;
  //   textarea.style.position = "fixed"; // Prevent scrolling to bottom
  //   document.body.appendChild(textarea);
  //   textarea.focus();
  //   textarea.select();
  //   try {
  //     document.execCommand("copy");
  //     alert("Link copied!");
  //   } catch (err) {
  //     alert("Copy failed. Please copy manually.");
  //   }
  //   document.body.removeChild(textarea);
  // };

  if (storeLoading) {
    return (
      <Container maxWidth="lg">
        <CircularProgress variant="indeterminate" />
      </Container>
    );
  }

  if (error || !isObject(storeData) || Object.keys(storeData).length === 0) {
    return <NotFound />;
  }

  const toggleExpanded = () => {
    setExpanded((prev) => !prev);
  };

  const getWords = (text, wordLimit = 50) => {
    const words = text?.split(" ") || [];
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ") + "...";
  };

  const shouldTruncate = storeData?.description?.split(" ")?.length > 50;

  const openEventDetails = (item) => {
    dispatch(setStore(item));
    // navigate(`/event/${item?.id}?event=${item?.name}`);

    navigate(`/web/${storeSlug}/event/${item.slug}`);

    // navigate(`/event/${item?.id}?event=${item?.name}`, {
    //   state: {
    //     storeID: storeID,
    //     liveEvent: item,
    //   },
    // });
  };

  const orderNow = () => {
    window.open(`https://${endpoint}.my-online.app?store_id=${storeID}`, "_blank", "noreferrer");
  };

  const bookAroom = () => {
    //     Ankita Sharma Ankit Bhatt I need button  after order now Book A Room and use this link "https://via.eviivo.com/DogCrookSO51"  https://dogandcrook.skiptheq.app/web/dog-and-crook-romsey  
    // Request Rejected
    window.open(bookAroomLink, "_blank", "noreferrer");
  };

  const renderButtons = () => {
    return (
      <Box className="btns-group">
        {orderNowEnabled && (
          <Button
            variant="outlined"
            size="large"
            color="primary"
            onClick={orderNow}
            // className="darkbtn"
            // sx={{ width: "100% !important", display: "flex !important", flex: "1" }}
            // fullWidth
            style={!bookAroomEnabled ? {
              flex: 1,
              display: "flex",
            } : {}}
          >
            Order Now
          </Button>
        )}
        {bookAroomEnabled && (
          <Button
            variant="contained"
            size="large"
            color="primary"
            onClick={bookAroom}
            className="darkbtn"
            // sx={{ width: "100% !important", display: "flex !important", flex: "1" }}
            // fullWidth
            sx={{
              backgroundColor: "#DE8F06 !important",
            }}
          >
            Book A Room
          </Button>)}
      </Box>
    );
  };

  return (
    <>
      <Container className="pt-4">
        {/* Hero Section */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            {isMultiStore && (
              <Typography className="title-backbtn mb-4">
                {location.key !== "default" && (
                  <Button
                    variant="outlined"
                    startIcon={
                      <ArrowBackRoundedIcon color="primary" fontSize="large" />
                    }
                    size="large"
                    onClick={() => navigate(-1)}
                    sx={{
                      backgroundColor: palette.common.white,
                    }}
                  ></Button>
                )}
                {storeData.name}
              </Typography>
            )}
            <img
              src={webImage && webImage !== '' ? webImage : storeData.image}
              alt="web_image"
              className="w-100 detail-img"
            />
            <Box className="d-flex justify-content-between mt-4 location-main-outer">
              <Typography className="address-outer">
                {" "}
                <LuMapPin />{" "}
                {`${storeData.address_line_1}, ${storeData.address_line_2}, ${storeData.city}`}
              </Typography>
              <Typography
                variant="body2"
                component="a"
                color="white"
                href={`https://www.google.com/maps/dir/?api=1&destination=${storeData.lat},${storeData.long}`}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ textDecoration: "none", cursor: "pointer" }}
                className="direction-outer"
              >
                <TbMapShare /> Get directions
              </Typography>
            </Box>
            <Box className="accordin-custom mobile-accordian">
              <OpeningHours store={storeData} />
              <Box className="btns-group">
                {bookTableEnabled && (
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    onClick={() => {
                      // navigate(`/store/${storeID}`);
                      navigate(`/web/${storeSlug}/book-a-table`);
                    }}
                    className="darkbtn"
                    style={!viewMenuEnabled ? {
                      flex: 1,
                      display: "flex",
                    } : {}}
                  >
                    Book a Table
                  </Button>
                )}
                {viewMenuEnabled && (
                  <MenuButton className="borderbtn" storeID={storeID} />
                )}
                {/* Order Now and Book A Room buttons */}
                {orderNowEnabled && (<Button
                  variant="outlined"
                  size="large"
                  color="primary"
                  onClick={orderNow}
                  style={!bookAroomEnabled ? {
                    flex: 1,
                    display: "flex",
                  } : {}}
                  >
                    Order Now
                  </Button>
                )}
                {bookAroomEnabled && (
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    onClick={bookAroom}
                    className="darkbtn"
                    sx={{
                      backgroundColor: "#DE8F06 !important",
                    }}
                  >
                    Book A Room
                  </Button>
                )}
              </Box>
            </Box>
            <Box p={3} className="about-data mt-4">
              <Typography
                variant="h5"
                gutterBottom
                color={"primary"}
                sx={{ fontWeight: "600" }}
              >
                About {storeData.name}
              </Typography>

              {storeInactiveNotice && (
                <Typography
                  variant="body2"
                  mb={2}
                  mt={1}
                  color="warning.main"
                  sx={{
                    padding: 1,
                    backgroundColor: "warning.light",
                    borderRadius: 1,
                  }}
                >
                  {storeInactiveNotice}
                </Typography>
              )}

              <Typography
                variant="body1"
                mb={0}
                mt={2}
                sx={{
                  textAlign: "justify",
                  maxWidth: 800,
                }}
                className="about-content"
              >
                {expanded || !shouldTruncate
                  ? storeData?.description
                  : getWords(storeData?.description)}
                {shouldTruncate && (
                  <Link
                    component="button"
                    onClick={toggleExpanded}
                    sx={{ mt: 1, display: "block" }}
                    className="readmore-btn"
                  >
                    {expanded ? "Read less" : "Read more"}
                  </Link>
                )}
              </Typography>

              <Facilities storeID={storeID} />
            </Box>
            <Box className="all-events-wrapper" ref={eventsRef}>
              <UpcomingEvents
                storeID={storeID}
                openEventDetails={openEventDetails}
                setEventData={setEventData}
                title="All Events"
              />
            </Box>

            <Box>
              <ImageGallery storeID={storeID} />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box className="accordin-custom desktop-accordian">
              <OpeningHours store={storeData} />
              <Box className="btns-group">
                {bookTableEnabled && (
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    onClick={() => {
                      // navigate(`/store/${storeID}`);
                      navigate(`/web/${storeSlug}/book-a-table`);
                    }}
                    className="darkbtn"
                    style={!viewMenuEnabled ? {
                      flex: 1,
                      display: "flex",
                    } : {}}
                  >
                    Book a Table
                  </Button>
                )}
                {viewMenuEnabled && (
                  <MenuButton className="borderbtn" storeID={storeID} />
                )}
              </Box>
              {/* {!isMultiStore && ( */}
              {renderButtons()}
              {/* )} */}
            </Box>
            <Box></Box>
            <Box>
              <Box
                gap={2}
                flexDirection={"row"}
                alignItems={"center"}
                justifyContent={"center"}
                flexWrap={"wrap"}
                display={"flex"}
              ></Box>
            </Box>
            {storeData.instagram_url ||
              storeData.facebook_url ||
              storeData.youtube_url ||
              storeData.x_url ? (
              <Box className="social-media-main mt-3 text-center">
                <Typography>
                  <RiUserAddLine /> Follow us on social media
                </Typography>
                <hr />
                <Typography className="social-media-links text-center justify-content-center">
                  {storeData.instagram_url && (
                    <Link href={storeData.instagram_url} target="_blank">
                      <FaInstagram />
                    </Link>
                  )}
                  {storeData.facebook_url && (
                    <Link href={storeData.facebook_url} target="_blank">
                      <FiFacebook />
                    </Link>
                  )}
                  {storeData.youtube_url && (
                    <Link href={storeData.youtube_url} target="_blank">
                      <CiYoutube />
                    </Link>
                  )}
                  {storeData.x_url && (
                    <Link href={storeData.x_url} target="_blank">
                      <RiTwitterXLine />
                    </Link>
                  )}
                </Typography>
              </Box>
            ) : null}

            {/* <Box className="sharefriends-outer mt-3">
              <Typography className="friends-share">
                <IoShareSocialOutline /> Share with friends
              </Typography>
              <Box>
                <Typography>
                  <FiFacebook /> Share on Facebook{" "}
                </Typography>
                <Typography>
                  <RiTwitterXLine /> Share on X (Formerly Twitter){" "}
                </Typography>
                <Typography
                  onClick={handleCopy}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <IoCopyOutline />
                  Copy Link
                </Typography>
              </Box>
            </Box> */}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default StoreDetails;
